import { ProfileService } from "@/common/api/Services/Profile";
import React, { useCallback, useEffect, useState } from "react";
import MVMIcon from "../../Common/MVMIcon";
import MvmSlider from "../../Common/MvmSlider";
import Spinner from "../../Common/Spinner";
const ProfileActivities = ({ userId, userName }) => {
    const [profileActivities, setProfileActivities] = useState();
    const [pageStatus, setPageStatus] = useState("loading");
    const getProfileActivities = async () => {
        try {
            const res = await ProfileService.getProfileActivities(userId);
            setProfileActivities(res);
            setPageStatus("success");
        }
        catch {
            setPageStatus("error");
        }
    };
    useEffect(() => {
        getProfileActivities();
    }, []);
    const renderActivities = useCallback(() => {
        if (profileActivities) {
            return profileActivities.map((activity) => (React.createElement("div", { className: "py-3", key: activity.exerciseTypeAlias },
                React.createElement("div", { className: "profile-activities-card" },
                    React.createElement("div", null,
                        React.createElement("p", { className: "profile-activities-activity-text" }, "Activity:"),
                        React.createElement(MVMIcon, { icon: activity.exerciseTypeAlias, width: 220, height: 180 }),
                        React.createElement("h3", { className: "ps-2" }, activity.exerciseType)),
                    React.createElement("div", null,
                        React.createElement("div", { className: "bg-secondary d-flex" },
                            React.createElement("div", { className: "ps-2 pt-1 flex-fill" },
                                React.createElement("p", { className: "profile-activities-stats-heading" }, "DISTANCE FOR THIS ACTIVITY"),
                                React.createElement("p", { className: "profile-activities-stats-number primary-color" },
                                    activity.totalDistance,
                                    React.createElement("span", { className: "small primary-color" }, activity.distanceUnit))),
                            React.createElement("div", { className: "profile-activities-stats-total-pct" },
                                React.createElement("p", { className: "profile-activities-stats-number" },
                                    activity.distancePct,
                                    React.createElement("span", { className: "white floating-small-text" }, "%")),
                                React.createElement("p", { className: "profile-activities-stats-heading" }, "OF TOTAL"))),
                        React.createElement("div", { className: "d-flex bg-primary pb-2 pt-1" },
                            React.createElement("div", { className: "ps-2 w-40" },
                                React.createElement("p", { className: "profile-activities-stats-heading" }, "THIS MONTH"),
                                React.createElement("p", { className: "profile-activities-stats-number" },
                                    activity.distanceMonth,
                                    React.createElement("span", { className: "small white" }, activity.distanceUnit))),
                            React.createElement("div", { className: "ps-2" },
                                React.createElement("p", { className: "profile-activities-stats-heading" }, "THIS YEAR"),
                                React.createElement("p", { className: "profile-activities-stats-number secondary-color" },
                                    activity.distanceYear,
                                    React.createElement("span", { className: "small secondary-color" }, activity.distanceUnit)))))))));
        }
        return React.createElement(React.Fragment, null);
    }, [profileActivities]);
    if (pageStatus === "loading") {
        return (React.createElement("div", { className: "mt-5" },
            React.createElement(Spinner, null),
            ";"));
    }
    if (profileActivities && profileActivities.length <= 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "profile-container profile-activities" },
        React.createElement("h2", { className: "text-center mb-3" },
            "ACTIVITIES ",
            React.createElement("span", { className: "secondary-color" }, "UNDERTAKEN")),
        React.createElement(MvmSlider, null, renderActivities())));
};
export default ProfileActivities;
